var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"a-btnNav",class:{ '-small' : _vm.small },attrs:{"to":_vm.link}},[_c('span',{staticClass:"a-btnNavAccent"}),_c('span',{staticClass:"a-btnNavBody",domProps:{"innerHTML":_vm._s(_vm.name)}})])}
var staticRenderFns = []

export { render, staticRenderFns }